/* Public rewards copy. No customer reads, balance writes, or invented fallback rates. */
(function () {
  'use strict';
  if (window.fpRewardsProgram) return;
  var integers = ['points_per_dollar_redeemed', 'earn_rate_bp', 'redemption_floor_points',
    'credit_expiry_months', 'plays_per_order', 'play_ttl_days', 'points_expiry_months',
    'referral_referee_points', 'referral_referrer_points', 'referral_referrer_plays', 'birthday_points',
    'game_requires_order_within_days', 'game_points_per_year', 'referral_hold_days',
    'birthday_lock_days', 'game_pending_days', 'max_game_points_per_play'];
  function valid(p) {
    return !!p && typeof p.earning_enabled === 'boolean' && typeof p.redemption_enabled === 'boolean'
      && (p.earn_basis === 'charged' || p.earn_basis === 'subtotal')
      && integers.every(function (k) { return Number.isSafeInteger(p[k]) && p[k] >= 0; })
      && p.points_per_dollar_redeemed > 0 && Number.isFinite(p.cents_per_point) && p.cents_per_point > 0
      && p.cents_per_point * p.points_per_dollar_redeemed === 100
      && p.values && Number.isSafeInteger(p.values.throws) && p.values.throws > 0
      && Array.isArray(p.values.bags) && p.values.bags.length === 6
      && p.values.bags.every(function (v) { return Number.isSafeInteger(v) && v >= 0; });
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function format(template, fields) {
    return String(template || '').replace(/\{([a-z_]+)\}/g, function (all, k) {
      return Object.prototype.hasOwnProperty.call(fields, k) ? String(fields[k]) : all;
    });
  }
  function describe(p, messages, gameEnabled) {
    if (!valid(p)) return null;
    var rate = (p.earn_rate_bp / 100) + '%';
    var worth = function (points) { return money(points * p.cents_per_point); };
    var min = Math.max(1, Math.ceil(p.redemption_floor_points / p.points_per_dollar_redeemed)) * p.points_per_dollar_redeemed;
    var gameMax = Math.min(p.max_game_points_per_play, p.game_points_per_year);
    var examplePoints = Math.floor(6000 * p.earn_rate_bp / (10000 * p.cents_per_point));
    var bonus = p.referral_referrer_plays > 0 ? format(messages.referral_bonus, { plays_label: p.referral_referrer_plays + ' ' + messages[p.referral_referrer_plays === 1 ? 'play_singular' : 'play_plural'] }) : '';
    var fields = { bonus: bonus, exclusions: p.earn_basis === 'charged' ? messages.charged_exclusions : '',
      rate: rate, basis: p.earn_basis === 'charged' ? 'the amount charged' : 'the eligible order subtotal',
      value: worth(1), per_dollar: p.points_per_dollar_redeemed, floor: min,
      referrer: p.referral_referrer_points, referee: p.referral_referee_points, hold: p.referral_hold_days,
      plays: p.plays_per_order, plays_label: p.plays_per_order + ' ' + messages[p.plays_per_order === 1 ? 'play_singular' : 'play_plural'], throws: p.values.throws, ttl: p.play_ttl_days,
      max: gameMax, recent: p.game_requires_order_within_days,
      pending: p.game_pending_days, cap: p.game_points_per_year, lock: p.birthday_lock_days,
    };
    var copy = {};
    ['lead', 'earn_label', 'shop_detail', 'refer_detail', 'play_detail', 'rate', 'earning_terms',
      'referral_terms', 'game_terms', 'demo_note'].forEach(function (k) { copy[k] = format(messages[k], fields); });
    copy.example = format(messages.example, { order: '$60', points: examplePoints, credit: worth(examplePoints) });
    copy.minimum = p.redemption_enabled ? format(messages.minimum, { points: min, amount: worth(min) }) : messages.redemption_paused;
    copy.birthday_detail = format(messages.birthday_detail, { points: p.birthday_points });
    copy.birthday_terms = format(messages.birthday_terms, { points: p.birthday_points, lock: p.birthday_lock_days });
    copy.expiry_terms = format(messages.expiry_terms, { points: p.points_expiry_months, credit: p.credit_expiry_months, plays: p.play_ttl_days });
    var values = {
      earn_percent: rate,
      referral_value: format(messages[p.referral_referee_points === p.referral_referrer_points ? 'referral_value' : 'referral_unequal'], { amount: worth(p.referral_referrer_points) }),
      birthday_value: worth(p.birthday_points),
      game_value: gameEnabled ? format(messages.game_value, { amount: worth(gameMax) }) : '—',
    };
    if (!gameEnabled) { copy.play_detail = messages.game_disabled; copy.game_terms = messages.game_disabled; }
    copy.earning_terms += ' ' + (p.redemption_enabled ? format(messages.conversion_terms, { floor: min }) : messages.redemption_paused);
    if (!p.earning_enabled) {
      Object.keys(values).forEach(function (k) { values[k] = '—'; });
      ['shop_detail', 'refer_detail', 'birthday_detail', 'play_detail', 'earning_terms', 'referral_terms', 'birthday_terms', 'game_terms'].forEach(function (k) { copy[k] = messages.earn_paused; });
      copy.lead = messages.lead_paused;
      copy.earn_label = messages.earn_paused;
      /* FP40 2026-10-08: `rate` now opens with the earn %, so a pause keeps only the point value
         (rate_paused); a messages payload without that key falls back to the pause line. */
      copy.rate = messages.rate_paused ? format(messages.rate_paused, fields) : messages.earn_paused;
      copy.example = messages.example_paused;
    }
    return { values: values, copy: copy };
  }
  window.fpRewardsProgram = { valid: valid, describe: describe };
  var root = document.querySelector('[data-fp-program-root]');
  if (!root) return;
  var status = root.querySelector('[data-fp-program-status]');
  var retry = root.querySelector('[data-fp-program-retry]');
  var terms = root.querySelector('[data-fp-program-terms]');
  var messages;
  try { messages = JSON.parse(root.querySelector('[data-fp-program-messages]').textContent); } catch (_) {
    root.setAttribute('data-program-state', 'unavailable');
    status.textContent = root.getAttribute('data-unavailable');
    terms.hidden = false;
    root.querySelectorAll('[data-fp-program-value]').forEach(function (el) { el.setAttribute('aria-busy', 'false'); });
    return;
  }
  var stage = root.querySelector('[data-fp-stage]');
  var originals = Array.prototype.map.call(root.querySelectorAll('[data-fp-program-copy]'), function (el) { return { el: el, text: el.textContent }; });
  var pending = false;
  function reset() {
    originals.forEach(function (item) { item.el.textContent = item.text; });
    root.querySelectorAll('[data-fp-program-value]').forEach(function (el) { el.textContent = '—'; el.setAttribute('aria-busy', 'true'); });
    if (stage) { stage.removeAttribute('data-program-ready'); stage.removeAttribute('data-cents-per-point'); }
  }
  async function refresh() {
    if (pending) return;
    pending = true;
    reset();
    root.setAttribute('data-program-state', 'loading');
    status.textContent = messages.loading;
    retry.hidden = true; terms.hidden = true;
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 10000);
    try {
      if (root.getAttribute('data-proxy') !== '1') throw new Error('unavailable');
      var response = await fetch('/apps/rewards?action=program', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('unavailable');
      var body = await response.json();
      var model = body.ok === true && describe(body.program, messages, root.getAttribute('data-game') === '1');
      if (!model) throw new Error('unavailable');
      root.querySelectorAll('[data-fp-program-value]').forEach(function (el) {
        el.textContent = model.values[el.getAttribute('data-fp-program-value')]; el.setAttribute('aria-busy', 'false');
      });
      originals.forEach(function (item) { item.el.textContent = model.copy[item.el.getAttribute('data-fp-program-copy')]; });
      if (stage) {
        stage.setAttribute('data-cents-per-point', String(body.program.cents_per_point));
        stage.setAttribute('data-program-ready', body.program.earning_enabled ? '1' : '0');
        stage.querySelectorAll('[data-bag]').forEach(function (bag) {
          var pill = bag.querySelector('[data-fp-bag-val]');
          if (pill) pill.textContent = body.program.earning_enabled ? body.program.values.bags[Number(bag.getAttribute('data-bag'))] + ' FP' : '—';
        });
      }
      status.textContent = body.program.earning_enabled ? '' : messages.earn_paused;
      root.setAttribute('data-program-state', body.program.earning_enabled ? 'ready' : 'paused');
    } catch (_) {
      root.setAttribute('data-program-state', 'unavailable');
      root.querySelectorAll('[data-fp-program-value]').forEach(function (el) { el.setAttribute('aria-busy', 'false'); });
      status.textContent = messages.unavailable;
      retry.hidden = false; terms.hidden = false;
    } finally { clearTimeout(timeout); pending = false; }
  }
  retry.addEventListener('click', refresh);
  refresh();
})();
